export default __webpack_public_path__ + "static/media/gg.ceb94b69.svg";